import {NgOptimizedImage} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell, MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef, MatNoDataRow,
    MatRow,
    MatRowDef,
    MatTable
} from '@angular/material/table';
import {MatTreeModule} from '@angular/material/tree';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {TranslatePipe} from '@ngx-translate/core';
import {ComponentsModule} from '../../../components/components.module';
import {CategoryTreeModel, ProductCategoryModel, ProductTableModel} from '../../../models/products.model';
import {ProductionService} from '../../../services/production.service';
import {ModalService} from '../../../services/modal/modal.service';
import {AlertService} from '../../../services/notify/alert.service';

@Component({
    selector: 'app-production-card-list',
    standalone: true,
    imports: [
        TranslatePipe,
        ComponentsModule,
        MatTreeModule,
        NgOptimizedImage,
        MatCell,
        MatCellDef,
        MatColumnDef,
        MatHeaderCell,
        MatHeaderRow,
        MatHeaderRowDef,
        MatRow,
        MatRowDef,
        MatTable,
        MatHeaderCellDef,
        MatNoDataRow,
    ],
    templateUrl: './production-card-list.component.html',
    styleUrl: './production-card-list.component.scss'
})
export class ProductionCardListComponent implements OnInit {
    categories: CategoryTreeModel[];
    currentCategory: ProductCategoryModel;

    parentCategoryCuid: string = null;

    cards: ProductTableModel[];

    cardType: 'PRODUCT' | 'SERVICE';

    viewMode: 'table' | 'grid' = 'grid';

    path: string[] = [];

    constructor(
        public modalService: ModalService,
        public router: Router,
        private sanitizer: DomSanitizer,
        protected productionService: ProductionService,
        protected alertService: AlertService,
    ) {
    }

    ngOnInit() {
        this.getAllProductCategories();
    }

    getAllProductCategories(categoryGuid?: string): void {
        this.productionService.getCategories(categoryGuid ?? null).subscribe({
            next: res => {
                this.categories = res.categories_tree;
                this.selectCategory(res.categories_tree[0].category);
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    selectCategory(category: ProductCategoryModel): void {
        this.currentCategory = category;

        this.getAllProductCards();
    }

    getAllProductCards(): void {
        this.productionService.gatProductCardsByCategory(this.currentCategory.cuid).subscribe({
            next: res => {
                this.cards = res.products;
                this.getImages();
                console.log(res);
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    getImages(): void {
        this.cards.forEach((card: ProductTableModel) => {
            console.log('start loading image');
            if (card.photo_first) {
                this.productionService.getPhotoInProductCard(card.puid, card.photo_first.ukey).subscribe({
                    next: res => {
                        card.photo_first.originImage = this.convertBlobToImage(res);
                    }, error: err => {
                        this.alertService.setAlert(err.message, 'blue');
                    }
                });
            }
        });
    }

    private convertBlobToImage(blob: Blob): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    }

    createProductCard(name: string, modal: NgbModalRef): void {
        const data = {
            title: name,
            categories_cuid: [this.currentCategory.cuid].toString(),
            card_type: this.cardType
        };

        this.productionService.createProductCard(data).subscribe({
            next: () => {
                this.getAllProductCards();
                modal.close();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    createCategory(name: string, modal: NgbModalRef, parentGuid?: string): void {
        const data = {
            title: name,
            parent_cuid: this.parentCategoryCuid,
        };

        this.productionService.createCategory(data).subscribe({
            next: () => {
                this.getAllProductCategories();
                modal.close();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    deleteCategory(category): void {
        // TODO нет эндпоинта, сделать как появится
    }

    changePath(category: CategoryTreeModel, index: number): void {

        if (this.path[index] === category.category.cuid) {
            this.path = this.path.slice(0, index);
        } else {
            this.path[index] = category.category.cuid;
            this.path = this.path.slice(0, index + 1);
        }

        console.log(this.path);
        this.selectCategory(category.category);
    }
}
